import { useState } from 'react';

/**
 * Estado compartido de paginación; cambiar el tamaño vuelve a la primera página.
 * @param {number} initialRowsPerPage Cantidad inicial de registros visibles.
 * @returns {Object} Página, tamaño y handlers compatibles con PaginationTable.
 */
export const usePagination = (initialRowsPerPage = 25) => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);

  return {
    page,
    setPage,
    rowsPerPage,
    handlePageChange: (_, value) => setPage(value),
    handleRowsPerPageChange: (event) => {
      setRowsPerPage(Number(event.target.value));
      setPage(1);
    },
  };
};
